import { render, staticRenderFns } from "./koejakso-view-vastuuhenkilo.vue?vue&type=template&id=56136f84&"
import script from "./koejakso-view-vastuuhenkilo.vue?vue&type=script&lang=ts&"
export * from "./koejakso-view-vastuuhenkilo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports